import {Component, effect, inject, signal} from '@angular/core';
import {MaterialModule} from '../../../../core/modules/material.module';
import {SharedModule} from '../../../../core/modules/shared.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {EditContentModal} from '../edit-forum-content/edit-content.modal';
import {MatDialog} from '@angular/material/dialog';
import moment from 'moment';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, PagesContainerComponent],
  providers: [ForumTalkService]
})

export class BannerComponent {
  private forumTalkService = inject(ForumTalkService);
  private dialog = inject(MatDialog);

  banners = signal<[]>([]);
  sort = signal('id');
  direction = signal('desc');
  pageIndex = signal(0);
  perPage = signal(50);
  pagination = signal<any>(null);
  displayedColumns = ['text', 'dateFrom', 'dateTo', 'active', 'edit', 'delete'];

  constructor() {
    effect(() => {
      const s = this.sort();
      const d = this.direction();
      const p = this.pageIndex();
      const pp = this.perPage();
      this.getBanners();
    });
  }

  getBanners() {
    this.forumTalkService.getBanners().subscribe((res: any) => {
      this.banners.set(res.banners);
      this.pagination.set(res.pagination);
    });
  }

  sortData(e) {
    if (!e.direction) {
      this.sort.set('id');
      this.direction.set('desc');
    } else {
      this.sort.set(e.active);
      this.direction.set(e.direction);
    }
    this.restoreScroll();
  }

  private restoreScroll() {
    const table = document.getElementById('bannersPage');
    if (table) {
      table.scrollTop = 0;
    }
  }

  handlePageEvent(e) {
    this.pageIndex.set(e.pageIndex);
    this.perPage.set(e.pageSize);
  }

  addBanner() {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.add_banner', type: 'banner'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          text: result.text,
          dateFrom: moment(result.dateFrom).toISOString(),
          dateTo: moment(result.dateTo).toISOString(),
          active: result.active
        };
        this.forumTalkService.addBanner(data).subscribe((res: any) => {
          this.getBanners();
        });
      }
    });
  }

  editBanner(banner) {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.edit_banner', type: 'banner', data: banner}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          text: result.text,
          dateFrom: moment(result.dateFrom).toISOString(),
          dateTo: moment(result.dateTo).toISOString(),
          active: result.active
        };
        this.forumTalkService.updateBanner(banner.id, data).subscribe((res: any) => {
          this.getBanners();
        });
      }
    });
  }

  deleteBanner(banner) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.forumTalkService.deleteBanner(banner.id).subscribe((res: any) => {
          this.getBanners();
        });
      }
    });
  }

}
